import '../sass/style.scss'

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

require('./bgFader.js')

$(document).ready(function() {

    $(window).resize(function() {
        positionToplink();
        fixResNav();
        fixColumns();
        fixHeight();
    });

    document.querySelector('.responsive-menu-toggle').addEventListener('click', function() {
        console.log('Foo')
        document.body.classList.toggle('show-sidebar')
    });

    positionToplink();

    $("#toplink").click(function() {
        $("html, body").animate({ scrollTop: 0 });
        // return false;
    });

    fixResNav();
    fixColumns();
    fixHeight();

    lightbox.option({
        albumLabel: 'Bild %1 von %2',
    });

    document.querySelector('#sb-site').addEventListener('click', e => {
        if (document.body.classList.contains('show-sidebar')) {
            e.preventDefault()
            e.stopPropagation()
            document.body.classList.remove('show-sidebar')
        }
    })

    $('#header .menu-item-has-children').hover(
        () => $('#header #menu > div > ul').addClass('hover'),
        () => $('#header #menu > div > ul').removeClass('hover'))
});

function fixResNav() {

    var wrap = $('.jPanelMenu-panel');

    var transform = $(wrap).css('transform');

    if ('matrix(1, 0, 0, 1, 0, 0)' == transform) {

        // collapsed
        return;
    }

    if ('matrix(1, 0, 0, 1, -250, 0)' == transform) {

        // expanded
        $(wrap).css('transform', 'matrix(1, 0, 0, 1, -233, 0)')
        return;
    }

    window.setTimeout(function() {

        fixResNav();
    }, 50);
}

function positionToplink() {

    if ($('#toplink').length > 0) {

        var cWidth = $('#contact').width();
        var bWidth = $('#bucher').width();

        if ($(window).width() > 1330) {

            var left = (cWidth - bWidth);
            $('#bucher').css('margin-left', (cWidth - bWidth) + 'px');
        } else {

            $('#bucher').css('margin-left', 'auto');
        }
    }
}

function fixColumns() {

    if ($('.imagelist').length > 0 && $('.cnt').length > 0 && $('.sidebar').length > 0) {

        var width = Math.floor($(window).width() / 3);

        if ($(window).width() > 1350) {

            $('.imagelist').css('width', width + 'px');
            $('.cnt').css('width', width + 'px');
            $('.sidebar').css('width', width + 'px');
        } else {

            $('.imagelist').css('width','100%');
            $('.cnt').css('width', '100%');
            $('.sidebar').css('width', '100%');
        }
    }
}

function fixHeight() {

    var doc = $(document).height();
    var win = $(window).height();

    var maxHeight = (doc > win? doc : win);

    if (maxHeight > $('#sb-site').height()) {

        $('#sb-site').css('height', maxHeight + 'px');
    }
}
